<template>
  <div>
    <v-layout>
      <v-flex md6>
        <label for="">Label</label>
        <v-text-field
            v-model="listData.label"
            outline
        ></v-text-field>
      </v-flex>
      <v-flex md6>
        <label for="">locale</label>
        <v-autocomplete
            v-model="listData.locale"
            :items="langIso"
            item-text="name"
            item-value="code"
            outline
            solo
            label="Search Languages"
        >
        </v-autocomplete>
      </v-flex>
    </v-layout>
    <draggable
        v-model="listData.buttonsList"
        group="buttonsList"
        handle=".handle-buttons"
        @start="drag=true"
        :animation="300"
        ghost-class="moving-card"
        @end="drag=false">
      <div class="card-inner-wrapper " v-for="(button,index) in listData.buttonsList" :key="index">
        <v-layout class="align-center">
          <v-flex xs1>
            <image-input  :small="true" :url="button.buttonIcon" @onImageUpload="button.buttonIcon = $event " :validation="false" ></image-input>
          </v-flex>
          <v-flex xs4>
            <label for="">Label</label>
            <v-text-field
                v-model="button.buttonLabel"
                outline
            />
          </v-flex>
          <v-flex xs4>
            <label for="">Type</label>
            <v-select
                v-model="button.buttonType"
                :items="buttonTypeList"
                outline
            />
          </v-flex>
          <v-flex xs4 v-if="button.buttonType === 'block'">
            <label for="">Block</label>
            <v-autocomplete
                v-model="button.block"
                :items="blocksList"
                item-text="name"
                item-value="id"
                outline
            ></v-autocomplete>
          </v-flex>
          <v-flex xs4 v-if="button.buttonType === 'url'">
            <label for="">URL</label>
            <v-text-field
                v-model="button.url"
                outline
            />
          </v-flex>
          <v-flex xs4 v-if="button.buttonType === 'phone'">
            <label for="">Phone</label>
            <v-text-field
                v-model="button.phone"
                outline
            />
          </v-flex>

        </v-layout>
        <div class="inner-block-actions">
          <v-btn
              @click="deleteButton(index)"
              fab small color=""
              class=""
          ><v-icon  color="red">delete_outline</v-icon></v-btn>
          <v-btn  class="handle-buttons" fab small color=""><v-icon color="#666">height</v-icon></v-btn>
        </div>
      </div>
    </draggable>
    <v-btn
        large round flat block
        class="primary--text"
        @click="addButton"
    >
      <v-icon>add_circle_outline</v-icon>
      Add New Button
    </v-btn>
  </div>


</template>

<script>
import imageInput from '../../../block-build/blocks/block-cards/common-inner-blocks/image-uploader-dropzone'
import draggable from 'vuedraggable'
import common from "../../../../utils/common";
import langIso from "../../../../utils/lang-iso"
export default {
  name: "introButtons",
  components: {
    draggable,
    imageInput
  },
  props: {
    listData: {
      type: Object,
      default: ()=> {
        return {}
      }
    }
  },
  data() {
    return {
      buttonTypeList: ['block', 'url', 'phone'],
      blocksList: [],
      langIso
    }
  },
  mounted() {
    this.getBlocksList()
  },
  methods: {
    addButton() {
      this.listData.buttonsList.push({
        buttonLabel: '',
        buttonIcon: '',
        buttonType: 'block',
        block: '',
        url: '',
        phone: ''
      })
    },
    getBlocksList() {
      this.$http_bot.get('/blocks')
          .then(response=>{
            this.blocksList = response.data
          })
          .catch(error=>{
            if (error.response.status === 401) {
              common.logOut()
            }
          })
    },
    deleteButton(index) {
      this.listData.buttonsList.splice(index,1)
    },
    updateButtons() {
      this.$emit('updateList', this.listData)
    },
    throttleUpdate: common.throttle(async function () {
      await this.updateButtons();
    }, 4000),
  },
  watch: {
    listData: {
      handler() {
        this.throttleUpdate()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.card-inner-wrapper {

}
</style>
